import React, { useState } from 'react';
import { useAuth } from '../AuthContext';

export default function ProfilePage() {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState({
    email: true,
    sms: false,
    jobAlerts: true,
    invoiceAlerts: true,
    complianceAlerts: true,
  });

  const toggleNotif = (key) => {
    setNotifications(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const infoRow = (label, value) => (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '12px 0', borderBottom: '1px solid var(--border)'
    }}>
      <span style={{ color: 'var(--text-muted)', fontSize: 13, fontWeight: 500 }}>{label}</span>
      <span style={{ color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{value}</span>
    </div>
  );

  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div className="page-header" style={{ marginBottom: 28 }}>
        <h1 className="page-title" style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>
          Profile &amp; Settings
        </h1>
        <p className="page-subtitle" style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>
          Account information and preferences
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        {/* User Profile */}
        <div className="card" style={{
          padding: 24, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)'
        }}>
          <h2 className="card-title" style={{ color: 'var(--text)', fontSize: 17, fontWeight: 600, margin: '0 0 20px' }}>
            Your Profile
          </h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
            <div style={{
              width: 64, height: 64, borderRadius: 16, background: 'var(--primary)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 24, fontWeight: 700, color: '#fff', flexShrink: 0
            }}>
              {user?.full_name?.split(' ').map(n => n[0]).join('') || 'U'}
            </div>
            <div>
              <div style={{ color: 'var(--text)', fontSize: 18, fontWeight: 700 }}>
                {user?.full_name || 'Team Member'}
              </div>
              <div style={{ color: 'var(--text-muted)', fontSize: 13, textTransform: 'capitalize' }}>
                {user?.role || 'Operator'}
              </div>
            </div>
          </div>
          {infoRow('Email', user?.email || 'N/A')}
          {infoRow('Role', (user?.role || 'operator').replace(/_/g, ' '))}
          {infoRow('Platform', 'The Forge Standard')}
          {infoRow('Status', 'Active')}
        </div>

        {/* Company Info */}
        <div className="card" style={{
          padding: 24, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)'
        }}>
          <h2 className="card-title" style={{ color: 'var(--text)', fontSize: 17, fontWeight: 600, margin: '0 0 20px' }}>
            Company Information
          </h2>
          {infoRow('Company', 'Miskulin Technologies')}
          {infoRow('Address', '121 Rainbow Falls Bay')}
          {infoRow('City', 'Chestermere, AB T1X 0S5, Canada')}
          {infoRow('Contact', 'investor@miskulintechnologies.com')}
          {infoRow('Platform', 'The Forge Standard')}
        </div>

        {/* Notification Settings */}
        <div className="card" style={{
          padding: 24, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)',
          gridColumn: '1 / -1'
        }}>
          <h2 className="card-title" style={{ color: 'var(--text)', fontSize: 17, fontWeight: 600, margin: '0 0 20px' }}>
            Notification Preferences
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 12 }}>
            {[
              { key: 'email', label: 'Email Notifications', desc: 'Receive updates via email' },
              { key: 'sms', label: 'SMS Notifications', desc: 'Get text message alerts' },
              { key: 'jobAlerts', label: 'Job Alerts', desc: 'Notifications for new and updated jobs' },
              { key: 'invoiceAlerts', label: 'Invoice Alerts', desc: 'Payment and invoice reminders' },
              { key: 'complianceAlerts', label: 'Compliance Alerts', desc: 'Safety and compliance deadlines' },
            ].map(n => (
              <div key={n.key} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '14px 16px', background: 'var(--bg)', borderRadius: 10,
                border: '1px solid var(--border)'
              }}>
                <div>
                  <div style={{ color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{n.label}</div>
                  <div style={{ color: 'var(--text-muted)', fontSize: 11, marginTop: 2 }}>{n.desc}</div>
                </div>
                <button
                  onClick={() => toggleNotif(n.key)}
                  style={{
                    width: 44, height: 24, borderRadius: 12, border: 'none', cursor: 'pointer',
                    background: notifications[n.key] ? 'var(--primary)' : 'var(--border)',
                    position: 'relative', transition: 'background 0.2s', flexShrink: 0
                  }}
                >
                  <div style={{
                    width: 18, height: 18, borderRadius: '50%', background: '#fff',
                    position: 'absolute', top: 3,
                    left: notifications[n.key] ? 23 : 3,
                    transition: 'left 0.2s'
                  }} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
